<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions({
      resetState: 'review-settings/resetState',
    }),
  },
  destroyed() {
    this.resetState();
  },
};
</script>

<template>
  <div class="review-settings-wrapper">
    <v-content>
      <router-view/>
    </v-content>
  </div>
</template>

<style lang="scss">
  .review-settings-wrapper {
    &__spinner {
      height: calc(100vh - 64px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ReviewSettingsWrapper.vue